export enum OnboardingStep {
  AutoSendOtp = 1,
  VerifyOtp = 2,
  FindPresence = 3,
  Username = 4,
  AddReleases = 5,
  Avatar = 6,
  TeamJoin = 7,
}

